import SearchSuggestions from './code/Scripts/Components/search-suggestions.vue';

export default {
  components: {
    SearchSuggestions,
  },
};
